var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 3.20833C0.875 1.43642 2.31142 0 4.08333 0C5.85527 0 7.29167 1.43642 7.29167 3.20833C7.29167 4.98025 5.85527 6.41667 4.08333 6.41667C2.31142 6.41667 0.875 4.98025 0.875 3.20833Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45832 3.20833C8.45832 4.08353 8.2013 4.89871 7.75867 5.5825C8.32853 6.10079 9.08569 6.41667 9.91665 6.41667C11.6886 6.41667 13.125 4.98025 13.125 3.20833C13.125 1.43642 11.6886 0 9.91665 0C9.08569 0 8.32853 0.315892 7.75867 0.834143C8.2013 1.51796 8.45832 2.33313 8.45832 3.20833Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.91659C0 8.62794 1.04467 7.58325 2.33333 7.58325H5.83333C7.12197 7.58325 8.16667 8.62794 8.16667 9.91659V12.2499C8.16667 12.5721 7.90551 12.8333 7.58333 12.8333H0.583333C0.261168 12.8333 0 12.5721 0 12.2499V9.91659Z",
    fill: "#232323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33336 9.91659V12.8333H13.4167C13.7388 12.8333 14 12.5721 14 12.2499V9.91659C14 8.62794 12.9553 7.58325 11.6667 7.58325H8.44214C8.99631 8.20246 9.33336 9.02018 9.33336 9.91659Z",
    fill: "#232323"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.cbfc7e36.svg";
export { ForwardRef as ReactComponent };